import { BaseProyectaService } from "./base-proyecta.service";
import { IMenuItem, INavbarItem, ISubMenuItem } from "../../models/navigation.model";
import { Constants, Enums, String, Utilities } from "../../utils/utilities";
import logo from '../../logotipo.jpg';

export interface INavigationService{
    getMenuData(langId: number): Promise<IMenuItem[]>;
    getTopMenuData(langId: number): Promise<IMenuItem[]>;
    getLogo(): Promise<string>;
    getNavBarData(langId: number):  Promise<INavbarItem[]>;
    getSubMenuData(listName: string, langId: number):  Promise<ISubMenuItem[]>;
}
 
export class NavigationService extends BaseProyectaService implements INavigationService {
    getMenuData(langId: number): Promise<IMenuItem[]> {
        return this.spListService.getItems<IMenuItem>({
            listName: Enums.ListTypes.Menu ,
            filter: String.Format(Constants.FiltersFormats.LANGUAGE_FILTER_BY_ID, langId),
            order: Constants.Orders.ORDER
        });
    }
    getTopMenuData(langId: number): Promise<IMenuItem[]> {
        return this.spListService.getItems<IMenuItem>({
            listName: Enums.ListTypes.TopMenu ,
            filter: String.Format(Constants.FiltersFormats.LANGUAGE_FILTER_BY_ID, langId)
        });
    }    

    getNavBarData(langId: number): Promise<INavbarItem[]> {
        return this.spListService.getItems<INavbarItem>({
            listName: Enums.ListTypes.NavBar ,
            filter: String.Format(Constants.FiltersFormats.LANGUAGE_FILTER_BY_ID, langId)
        });
    }    

    getSubMenuData(listName: string, langId: number): Promise<ISubMenuItem[]> {
        return this.spListService.getItems<ISubMenuItem>({
            listName: listName ,
            filter: String.Format(Constants.FiltersFormats.LANGUAGE_FILTER_BY_ID, langId)
        });
    }   
 
    public async getLogo():  Promise<string> {
        if(Utilities.isNullObject(this.params)){
            return logo;
        }
        const logoUrl = await this.spWebService.getLogo();
        return logoUrl;
    }    
}


